<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="unitForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputUnitAddName"
							formControlName="Name" placeholder="{{ 'NAME' | translate }}" maxlength="20" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.KeyboardCode, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.KeyboardCode, 'label')">{{ 'CODE_CALL' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.KeyboardCode, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputUnitAddCode"
							formControlName="KeyboardCode" placeholder="{{ 'CODE_CALL' | translate }}" maxlength="8" />
					</div>
				</div>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.Description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Description, 'label')">{{ 'DESCRIPTION' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="inputUnitAddDesc"
							formControlName="Description" placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="40" />
					</div>
				</div>
			</div>
		</div>
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium mt-3 pb-1">
				{{ 'CONTACT_LIST' | translate }}
			</div>
			<div class="col-12 flex align-items-center justify-content-center text-xl font-medium pt-0">
				{{'CONTACT_LIST_MAX' | translate}}
			</div>
		</div>
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-100 border-bottom-1"
					[ngClass]="simpleInputTextLayout('borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="simpleInputTextLayout('label')">{{
						'CONTACT_SELECT' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="simpleInputTextLayout('borderInput')">
						<p-autoComplete [suggestions]="filteredContacts" [ngClass]="dynamicInputTextWidth()" appendTo="body"
							[styleClass]="dynamicInputTextWidth()" [formControl]="contactsCtrl"
							placeholder="{{ 'CONTACT' | translate }}" inputStyleClass="pl-6 sm:pl-5 border-noround-right"
							(completeMethod)="filterContacts($event)" [dropdown]="true" panelStyleClass="text-center"
							[forceSelection]="true" field="Name">
						</p-autoComplete>
					</div>
				</div>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<p-button id="addMtmaContactUnit" label="{{ 'ADD_CONTACT_SELECT' | translate }}" (click)="addContactUnit()"
					[disabled]="checkContactsCtrl()" icon="pi cm-plus" [rounded]="false" [text]="true" severity="primary"
					styleClass="font-bold border-primary">
				</p-button>
			</div>
			<div *ngFor="let contact of this.unit.ContactsInfo, index as cont" class="col-12" [ngClass]="customPaddingX()">
				<div class="flex flex-row align-items-center justify-content-between">
					<span>{{cont+1}} - {{contact.Contact.Name}} {{getRuleData(contact)}}</span>
					<div>
						<p-button pTooltip="{{ 'ORDER_UP' | translate }}" class="" tooltipPosition="bottom"
							[disabled]="cont===0" icon="pi cm-angle-up" size="large" (click)="orderUp(cont, contact)"
							[rounded]="false" [text]="true" severity="primary">
						</p-button>
						<p-button pTooltip="{{ 'ORDER_DOWN' | translate }}" class="" tooltipPosition="bottom"
							[disabled]="cont+1>=this.unit.ContactsInfo.length" icon="pi cm-angle-down" size="large"
							(click)="orderDown(cont, contact)" [rounded]="false" [text]="true" severity="primary">
						</p-button>
						<p-button pTooltip="{{ 'EDIT' | translate }}" class="" tooltipPosition="bottom" icon="pi cm-pencil"
							size="large" (click)="editContact(contact)" [rounded]="false" [text]="true" severity="secondary">
						</p-button>
						<p-button pTooltip="{{ 'DELETE' | translate }}" class="" tooltipPosition="bottom" icon="pi cm-trash"
							size="large" (click)="deleteContact(cont)" [rounded]="false" [text]="true" severity="danger">
						</p-button>
					</div>
				</div>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>